function makeHeaderSticky() {
    $('.promo-header').css('position', 'fixed');
    $('.promo-header').css('top', '0');
    $('.promo-header').css('z-index', '999');
    $('.container-fluid-header').css('position', 'fixed');
    $('.container-fluid-header').css('top', '60px');
    $('.container-fluid-header').css('z-index', '999');
    $('body').css('padding-top', '124px');
}

function addDrawstringBagIfNeeded(callback) {
    $.getJSON('/cart.js', {}, function (cart) {    
      console.log('cart');
      console.log(cart);
      let count = 0;
      let already_in_bag = false;
      for(let i = 0; i < cart.items.length; ++i) {
        let item = cart.items[i];
        if(item.title.toLowerCase().indexOf('sample') > -1) {
          count += item.quantity;
        }
        if(item.variant_id == '32015654879277') {
          already_in_bag = true;
        }
      }
      if(!already_in_bag && count >= 3) {
        let data = {
          items: [{id: '32015654879277', quantity: 1}, {id: '43748587700373', quantity: 1}]
        };
        $.post('/cart/add.json', data, function(response) {
          if(typeof callback == 'function') {
            callback();
          }    
        }).fail(function (error) {
          console.log('error');
          console.log(error);
          if(typeof callback == 'function') {
            callback();
          }
        });
      } else {
        if(typeof callback == 'function') {
          callback();
        }
      }
    });
  }